import { styled } from "styled-components";

export const StyledForm = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const StyledInputWrapper = styled.div`
  display: inherit;
  flex-direction: inherit;
  align-items: inherit;
  width: inherit;
`;

export const StyledInput = styled.input`
  background: ${(props) => props.theme.color.inputBackground};
  font-family: ${(props) => props.theme.font.family.main};
  display: flex;
  justify-content: center;
  width: inherit;
  border-radius: 10px;
  height: 4rem;
  text-align: center;
  font-size: ${(props) => props.theme.font.size.title.medium};
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const FormLabel = styled.span`
  color: ${(props) => props.theme.color.inputLabel};
  font-size: ${(props) => props.theme.font.size.title.medium};
  font-family: ${(props) => props.theme.font.family.title};
`;

export const ErrorMessage = styled.label`
  margin-top: 0.5rem;
  color: ${(props) => props.theme.color.inputError};
  font-size: ${(props) => props.theme.font.size.title.small};
  font-family: ${(props) => props.theme.font.family.main};
  text-align: center;
`;

export const FormTitle = styled.label<{ $fontSize: string }>`
  color: ${(props) => props.theme.color.tertiary};
  font-family: ${(props) => props.theme.font.family.title};
  text-shadow: ${(props) => props.theme.font.elevation.hard.big};
  font-size: ${(props) => props.$fontSize};
  text-align: center;
`;
